import AbstractRsvpDetailsPageController from './abstract-details-controller';

export default class RsvpDetailsOptionLinksPageController extends AbstractRsvpDetailsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);

        this.navService = this.injector.get('NavService');

        this.availableGuestlistObjects = [];
        this.currentGuestlistObject = null;
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();

        this.availableGuestlistObjects = _.map(this.guestlist.bo_objects, (row) => {
            return {
                object: {
                    id: row.object.id,
                    type: row.object.type_label,
                    label: row.object.label
                }
            }
        });

        if (!this.currentGuestlistObject && !_.isEmpty(this.availableGuestlistObjects)) {
            this._updateCurrentGuestlistObject(_.first(this.availableGuestlistObjects));
        }

        this._updateTabs();
    }

    _updateTabs() {
        const customs = [];
        _.each(this.availableGuestlistObjects, (glObject) => {
            customs.push({
                label: _.get(glObject, 'object.label'),
                active: _.get(glObject, 'object.id') === _.get(this.currentGuestlistObject, 'object.id'),
                action: () => {
                    this._updateCurrentGuestlistObject(glObject);
                }
            });
        });

        this.navService.setSideNavCustoms(customs);
    }

    _updateCurrentGuestlistObject(newEntry) {
        this.currentGuestlistObject = _.cloneDeep(newEntry);
        this.scope.$applyAsync();
        this._updateTabs();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/details/option-links-controller.js